import { useQueryClient } from '@tanstack/react-query';
import { useTable } from 'src/components/table';
import { Order_By, useCertificatesQuery, useDeleteCertificatesMutation } from 'src/graphql';
import UseSearch from 'src/hooks/use-search';
import { useLocales } from 'src/locales';
import { orderBy } from 'src/utils/order-by';
export type RefBooksFormType = {
  matnId: string;
  sortBy: string | undefined;
  sortDirection: Order_By.Asc | Order_By.Desc | undefined;
  bookAuthor?: string;
  bookName?: string;
  createdAt?: string;
};

const useCertificates = () => {
  const table = useTable({ defaultRowsPerPage: 10, defaultCurrentPage: 0 });
  const queryClient = useQueryClient();
  const { t } = useLocales();

  const { methods, query, handleSearch, setQuery } = UseSearch<{
    sortBy: string;
    sortDirection: Order_By.Asc | Order_By.Desc | undefined;
  }>({});

  // #region Services
  const { data, isLoading } = useCertificatesQuery({
    offset: table.offset,
    limit: table.rowsPerPage,
    search: query.search ? { _ilike: `%${query.search}%` } : undefined!,
    order_by:
      methods.watch().sortBy && methods.watch().sortDirection
        ? orderBy(methods.watch().sortBy, methods.watch().sortDirection)
        : undefined,
  });

  const { mutate, isLoading: isDeleting } = useDeleteCertificatesMutation({
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['Certificates'] }),
  });
  // #endregion Services

  // #region Handlers
  const handleDeleteCert = (certificateId: string) => {
    mutate({ certificateId });
  };
  // #endregion Handlers
  return {
    t,
    isDeleting,
    methods,
    handleDeleteCert,
    handleSearch,
    query,
    setQuery,
    isLoading,
    data,
    table,
  };
};

export default useCertificates;
